<template>
  <div class="qa">
        <Navigation></Navigation> 
        <div class="bg"></div>
        <div class="mb_cartoon_bg"></div>
        <img src="../assets/images/back_btn.png" alt="" class="back_btn" @click="goback">
        <div class="qa_content">
            <ul class="qa_tags">
                <li  v-for="(item,index) in  qaTags" :key="index" 
                @click="isActiveIndex=index" 
                :class="{'active':isActiveIndex==index}">
                    {{item}}
                </li>
            </ul>
            <ul class="qa_list">
                <li v-for="(item,index) in qaList" :key="index">
                    <h3 @click="qaClick(index);">
                        <i>Q：</i>
                        <p>{{item.problem}}</p>
                        <span class="add" v-show="activeIndex!=index">+</span>
                        <span class="less" v-show="activeIndex==index">-</span>
                    </h3>
                    <div class="answer" :class="{active:activeIndex===index}">
                        <i>A：</i>
                        <div class="answer_list" v-html="item.answer">
                        </div>
                    </div>
                </li>
            </ul>
        </div>
  </div>
</template>

<script>
import Navigation from '../components/navigation'
import getQueryString from '@/methods/getQueryString'

import api from '@/api'
export default {
  name: 'cartoon',
    components:{
      Navigation
  },
  data(){
      return{
        isActiveIndex:0,
        isOpen:true,
        qaTags: ['よくあるご質問','ゲームの引継ぎについて','元宝の購入について','その他'],
        qaListArr:[],
        activeIndex:0,
      }
  },
  mounted(){
    this.getQaList()
    this.isActiveIndex = getQueryString('qaId')-1;
  },
  computed:{
      qaList(){
            return this.qaListArr.filter((e,i)=>{
              return e.tag==this.qaTags[this.isActiveIndex];
          })
      }
  },
  methods:{ 
        goback(){
            this.$router.back(-1)
        },
        getQaList(){
            api.getQaList()
            .then((res) => {
                this.loading = false
                let resData = res.data
                if(resData.code === 200){
                    this.qaListArr = resData.data
                    this.totalPages = resData.totalPages
                }
            })
        },
        qaClick(index){
            this.isOpen=!this.isOpen;
            if(!this.isOpen && this.activeIndex==index){
                this.activeIndex = null;
            }else{
                this.activeIndex = index;
            }
        }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
     .bg{
        background: url('../assets/images/news_bg.png') no-repeat;
        background-attachment: fixed;
        background-repeat: no-repeat;
        background-size: cover;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
    }
    .mb_cartoon_bg{
        background: url('../assets/images/mb_news_bg.png') no-repeat;
        background-repeat: no-repeat;
        background-size: cover;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
        display: none;
    }
    .qa{
        width: 100%;
        height: 100%;
        text-align: left;
    }
    .back_btn{
        width:232px;
        margin-top: 150px;
        margin-left: 80px;
        cursor: pointer;
          visibility: hidden;
    }
    .qa_content{
        width: 80%;
        position: relative;
        top: 0px;
        left: 50%;
        text-align: center;
        transform: translateX(-50%);
        .qa_tags{
            li{
                display: table-cell;
                vertical-align: middle;
                word-wrap: break-word;
                color: #fff;
                width: 800px;
                height: 220px;
                font-size: 70px;
                font-weight: 500;
                border-right:1px solid #fff;
                background-color: #ae7b37;
                cursor: pointer;
                padding: 20px;
            }
            li.active{
                background-color: #dbbe6e;
            }
            li:nth-child(4){
                 border-right:none;
            }
        }
        .qa_list{
            padding-top: 50px;
            text-align: left;
            i{
                color: #dbbe6e;
                font-size: 100px;
                font-weight: 700;
                vertical-align: middle;
            }
            span{
                display: inline-block;
                background-color: #dbbe6e;
                color: #fff;
                width: 100px;
                height: 100px;
                line-height: 100px;
                border-radius: 100%;
                font-size: 100px;
                font-weight: 700;
                text-align: center;
                vertical-align: middle;
                float: right;
            }
            li{
                margin-bottom: 20px;
                h3{
                    font-size: 70px;
                    cursor: pointer;
                    margin-bottom: 30px;
                    p{
                        display: inline-block;
                        width: 85%;
                        vertical-align: text-top;
                    }
                }
                .answer{
                    max-height:0;
                    font-size: 50px;
                    overflow: auto;
                    transition: all 1s;
                    .answer_list{
                        display: inline-block;
                        vertical-align:text-top;
                    }
                }
                
                
            }
            .answer.active{
                max-height:750px;
             }
        }
    }
   
   
    
// 移动端
@media screen and (max-width: 750px) {
    .news_tags{
        li{
            font-size: 30px;
        }
    }
    .bg{
        display: none;
    }
    .mb_cartoon_bg{
        display: block;
    }
    .back_btn{
        width: 400px;
        margin-top: 400px;
    }
    .qa_content{
        width: 100%;
        .qa_tags{
            li{
                width: 1000px;
                height: 500px;
                font-size: 120px;
            }
        }
        .qa_list{
            padding: 80px 50px;
            i{
                font-size: 200px;
                vertical-align: middle;
            }
            span{
                width: 200px;
                height: 200px;
                line-height: 200px;
                font-size: 250px;
                margin-right:80px;
            }
            li{
                margin-bottom: 50px;
                h3{
                    font-size: 150px;
                    margin-bottom: 120px;
                     p{
                    width: 80%;
                    }
                }
                
                .answer{
                    font-size: 150px;
                    .answer_list{
                        display: inline-block;
                        width:85%;
                    }
                }
            }
            .answer.active{
                max-height:2000px;
             }
        }
    }
   
}
</style>
